import styled from 'styled-components';

import { DEVICE } from '@hero/constants';

const CustomSelectWrapper = styled.div`
  display: inline-block;
`;

const Wrapper = styled.div`
  ${DEVICE.mobile.max} {
    width: 100%;

    ${CustomSelectWrapper} {
      width: 100%;
    }
  }
`;

export { CustomSelectWrapper, Wrapper };
